import type { DistrictNcesId } from "@nimble/datamodel/types/ncesId";
import { NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import { getDistrictData } from "@/lib/api-clients/candidate-api-client";

const DISTRICT_DATA_STALE_TIME_MS = 5 * 60 * 1000;

export default function useDistrictData({
  ncesId,
}: {
  ncesId: DistrictNcesId;
}) {
  return useQuery({
    queryKey: [`district-data-${ncesId}`],
    queryFn: async () => {
      return await getDistrictData(
        NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY,
      )(ncesId);
    },
    staleTime: DISTRICT_DATA_STALE_TIME_MS,
  });
}
